import { NavLink } from "react-router-dom";
import { Home, User, Share2 } from "lucide-react";

const items = [
  { to: "/app/home", icon: Home, label: "Domov", id: "nav-home" },
  { to: "/app/profile", icon: User, label: "Profil", id: "nav-profile" },
  { to: "/app/share", icon: Share2, label: "Zdieľať", id: "nav-share" },
];

export function CandidateNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-50 backdrop-blur-xl bg-white/85 border-t border-slate-200 shadow-[0_-4px_32px_rgba(0,0,0,0.06)]">
      <div className="flex items-stretch justify-around px-2 py-2">
        {items.map((it) => (
          <NavLink
            key={it.to} to={it.to} data-testid={it.id}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-5 py-2 rounded-2xl transition-colors ${isActive ? "text-blue-700 bg-blue-50" : "text-slate-400 hover:text-slate-700"}`
            }
          >
            <it.icon size={22} />
            <span className="text-[11px] font-semibold">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
